<template>
    <div :class="prefixCls">
        <span :class="`${prefixCls}-more`" v-if="hasMore" @click="handleLoad">
            {{loading ? t('page.loading') : t('page.loadMore')}}
            <i :class="[`${prefixCls}-icon`, {
                    [`${prefixCls}-icon-loading`]: loading
                }]"></i>
        </span>
        <span v-if="!hasMore && hasData">
            {{t('page.noMore')}}
        </span>
    </div>
</template>
<script>
    import Locale from '../../../mixins/locale'

    const prefixCls = 'yy-page'
    export default {
        name: 'YYPage',
        mixins: [Locale],
        props: {
            hasMore: {
                type: Boolean,
                default: true
            },
            loading: {
                type: Boolean,
                default: false
            },
            hasData: {
                type: Boolean,
                default: false
            },
            error: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                prefixCls: prefixCls
            }
        },
        methods: {
            handleLoad() {
                if (!this.loading) {
                    this.$emit('on-load')
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/base/page/page.vue